<template lang="pug">
.app-markdown(v-html="markdownToHtml")
</template>

<script>
import { marked } from 'marked';

export default {
  name: 'AppMarkdown',
  props: {
    markdown: {
      type: String,
      required: true,
    },
  },
  computed: {
    markdownToHtml() {
      return marked.parse(this.markdown);
    },
  },
};
</script>
